import React from 'react';
import { Redirect } from "react-router-dom";
import { userService } from '../../_services';
import { useMultiplePopups } from '../../hooks/usePopup';
import PagesWrapper from '@/components/ui/shared/PagesWrapper';
import { Card, CardContent } from '@/components/ui/card';
import { BetaBadge } from '@/components/ui/BetaBadge';
import { Activity, DollarSign, FileText } from 'lucide-react';

import ReportPopup from './ReportPopup';
import PayoutReportPopup from './PayoutReport';
import DashboardUsageAnalyticsPopup from './DashboardUsageAnalyticsPopup';

function Reports({ AnalyticData }) {
    const { popups, togglePopup, closePopup } = useMultiplePopups(['commissionPayout', 'adminPayout', 'dashboardUsage']);

    const userType = userService.Get_User_Type();
    if (userService.Check_LoggedIn_Status() === 'Login') return <Redirect to="/login" />;
    if (['wholesaler', 'distributor', 'subadmin'].includes(userType?.toLowerCase())) return <Redirect to='/pageNotFound' />;

    const reportItems = [
        { id: 'commissionPayout', title: 'Commission Payout Report', description: 'View commission payout details', icon: DollarSign, onClick: () => togglePopup('commissionPayout') },
        { id: 'adminPayout', title: 'Admin Payout Report', description: 'View admin payout summary', icon: FileText, onClick: () => togglePopup('adminPayout') },
        { id: 'dashboardUsage', title: 'Dashboard Usage Analytics', description: 'View dashboard usage activity', icon: Activity, onClick: () => togglePopup('dashboardUsage') }
    ];

    return (
        <PagesWrapper>
            <div className="space-y-6">
                <div className="flex items-center">
                    <h1 className="text-2xl font-semibold text-foreground">
                        Reports
                        <BetaBadge />
                    </h1>
                </div>

                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {reportItems.map((item) => {
                        const Icon = item.icon;
                        return (
                            <Card key={item.id} className="cursor-pointer hover:shadow-md transition-all hover:border-primary/50 group" onClick={item.onClick}>
                                <CardContent className="p-3 sm:p-4">
                                    <div className="flex items-start gap-4">
                                        <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center shrink-0 group-hover:bg-primary/20 transition-colors">
                                            <Icon className="h-6 w-6 text-primary" />
                                        </div>
                                        <div className="min-w-0 flex-1">
                                            <p className="font-medium text-foreground">{item.title}</p>
                                            <p className="text-sm text-muted-foreground mt-1">{item.description}</p>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        );
                    })}
                </div>
            </div>

            {popups.commissionPayout && <ReportPopup text='Commission Payout Report' closePopup={() => closePopup('commissionPayout')} />}
            {popups.adminPayout && <PayoutReportPopup text='Admin Payout Report' closePopup={() => closePopup('adminPayout')} />}
            {popups.dashboardUsage && <DashboardUsageAnalyticsPopup closePopup={() => closePopup('dashboardUsage')} />}
        </PagesWrapper>
    );
}

export default Reports;
